import { animate } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const siteNavigation = document.querySelector('.site-navigation');

    // Check if the homepage hero block exists
    if (!siteNavigation) {
        return;
    }

    const siteNavigationLogo = siteNavigation.querySelector('.site-navigation__logo');
    const siteNavigationMenu = siteNavigation.querySelector('.site-navigation__menu');
    const siteNavigationBurgerToggle = siteNavigation.querySelector('.site-navigation__burger-toggle');
    const siteNavigationLogoPaths = siteNavigationLogo.querySelectorAll('svg path');
    const siteNavigationTop = siteNavigation.querySelector('.site-navigation__top');
    const siteHtmlWrapper = document.documentElement; // Reference to the <html> element

    animate(siteNavigation, 
        {
            opacity: [0, 1],              // Fade from 0 to 1
        },
        {
            duration: 0.6,                // Global duration for the entire animation
            ease: 'ease-out',             // Global duration for the easing
            delay: 1.75,
        }
    );

    const siteNavigationBurgerToggleOpenIcon = `
        <svg width="40" height="29" viewBox="0 0 40 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="5" rx="2.5" fill="white"/>
            <rect y="12" width="40" height="5" rx="2.5" fill="white"/>
            <rect y="24" width="40" height="5" rx="2.5" fill="white"/>
        </svg>
    `;

    const siteNavigationBurgerToggleCloseIcon = `
        <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.500122" y="25.7776" width="36.455" height="4.55688" rx="2.27844" transform="rotate(-45 0.500122 25.7776)" fill="#001330"/>
            <rect x="26.2777" y="29" width="36.455" height="4.55688" rx="2.27844" transform="rotate(-135 26.2777 29)" fill="#001330"/>
        </svg>
    `;

    function navigationMobileToggle() {
        // Toggle the visibility of the site navigation
        if (siteNavigationMenu.classList.contains('hidden')) {
            siteNavigationMenu.classList.remove('hidden');
            siteNavigationMenu.classList.add('block');
            siteNavigationBurgerToggle.innerHTML = siteNavigationBurgerToggleCloseIcon; // Switch to close icon

            // Change the fill color of the logo paths to red
            siteNavigationLogoPaths.forEach(path => {
                path.setAttribute('fill', '#001330');
            });

            siteHtmlWrapper.classList.add('overflow-hidden');

            // Remove bg-primary class
            siteNavigationTop.classList.remove('bg-primary', 'lg:bg-transparent');
        } else {
            navigationReset();
        }
    }

    function navigationReset() {
        siteNavigationMenu.classList.remove('block');
        siteNavigationMenu.classList.add('hidden');
        siteNavigationBurgerToggle.innerHTML = siteNavigationBurgerToggleOpenIcon;

        siteNavigationLogoPaths.forEach(path => {
            path.setAttribute('fill', 'white');
        });

        siteHtmlWrapper.classList.remove('overflow-hidden');

        if (window.scrollY > 0) {
            siteNavigationTop.classList.add('bg-primary', 'lg:bg-transparent');
        }
    }

    function handleScroll() {
        if (window.scrollY > 0) {
            siteNavigationTop.classList.add('bg-primary', 'lg:bg-transparent');
        } else {
            siteNavigationTop.classList.remove('bg-primary', 'lg:bg-transparent');
        }
    }

    siteNavigationBurgerToggle.innerHTML = siteNavigationBurgerToggleOpenIcon;
    siteNavigationBurgerToggle.addEventListener("click", navigationMobileToggle);
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', navigationReset);
});